/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteMeasure$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * The measure id
 */
  measureId: number;
}

export function deleteMeasure(http: HttpClient, rootUrl: string, params: DeleteMeasure$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteMeasure.PATH, 'delete');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('measureId', params.measureId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteMeasure.PATH = '/customers/{customerId}/measures/{measureId}';
